import { render } from "./listaProdutos.vue?vue&type=template&id=7375ec9c"
import script from "./listaProdutos.vue?vue&type=script&lang=js"
export * from "./listaProdutos.vue?vue&type=script&lang=js"

import "./listaProdutos.vue?vue&type=style&index=0&id=7375ec9c&lang=css"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__